<template>
  <div>
Snoozed
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>